import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/state/auth/auth';
import { get, every } from 'lodash';
import type { OrgUnitActions, Permissions } from 'src/graphql/_generated';
import Loader from 'src/components/Loader/Loader';

type OrgUnitPermissionKey = keyof Omit<OrgUnitActions, '__typename'>;
type ProfilePermissionKey = keyof Omit<Permissions, '__typename'>;

interface AccessGuardProps {
  children: React.ReactNode;
  requiredPermissions: {
    activeOrganisation?: OrgUnitPermissionKey[];
    activeWorkspace?: OrgUnitPermissionKey[];
    profile?: ProfilePermissionKey[];
  };
}

export const AccessGuard: React.FC<AccessGuardProps> = ({ children, requiredPermissions = {} }) => {
  const { profile } = useAuth();

  const orgPermissionsPassed = requiredPermissions.activeOrganisation
    ? every(requiredPermissions.activeOrganisation, (el) =>
        get(profile, `activeOrganisation.actionsOnThisOrganisation.${el}`),
      )
    : true;

  const workspacePermissionsPassed = requiredPermissions.activeWorkspace
    ? every(requiredPermissions.activeWorkspace, (el) => get(profile, `activeWorkspace.actionsOnThisWorkspace.${el}`))
    : true;

  const profilePermissionsPassed = requiredPermissions.profile
    ? every(requiredPermissions.profile, (el) => get(profile, `permissions.${el}`))
    : true;

  const hasAccess = orgPermissionsPassed && workspacePermissionsPassed && profilePermissionsPassed;

  if (!hasAccess) {
    return <Navigate to="/home" replace />;
  }

  // return <Loader />;

  return <>{children}</>;
};
